<template>
  <div>
    <el-dialog
      title="提交成功"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="500px"
      @close="createAgain"
      center
      custom-class="dialogClass"
    >
      <p style="font-size: 16px; text-align: center">
        审核通过后产品将自动上架，请耐心等待。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createAgain">继续发布新样品</el-button>
        <el-button
          style="margin-left: 20px"
          type="primary"
          @click="toSamplePage('submitSuccessToHistoryTab2')"
          >查看待审核样品</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    createAgain() {
      this.$emit('create-again');
    },
    toSamplePage(val) {
      this.$emit('to-sample-page', val);
    },
  },
};
</script>
